<!-- Breadcrumb -->
<div class="content-breadcrumb div-breadcrumb">
  <em class="fa fa-list-ol icon-breadcrumb"></em>
  <span class="text-breadcrumb">Procedimentos</span>
</div>

<div class="container-fluid">
  <div class="row mt-4">
    <div class="col">
          <form class="form-inline" (ngSubmit)="filterForm.form.valid && buscarProcedimentos()" #filterForm="ngForm">
              <div class="input-group w-25">
                <input class="form-control" type="text" placeholder="Buscar..." id="valueFilter" name="valueFilter" [(ngModel)]="valueFilter">
                <button class="btn btn-primary"><i class="fa fa-search"></i></button>
              </div>
          </form>
      </div>
      <div class="col-auto">
          <button type="button" class="btn btn-primary float-right" (click)="novoProcedimento(content)"> <i class="fa fa-plus"></i> &nbsp; Procedimento</button>
      </div>
  </div>

  <app-card titleCard="Lista de procedimentos cadastrados">
      <div class="table-responsive">
          <table class="table table-bordered table-hover text-center text-table">
              <thead>
                  <tr class="table-active">
                      <th style="width: 150px">ID</th>
                      <th>Código</th>
                      <th>Titulo</th>
                      <th>Valor</th>
                      <th style="width: 150px">Status</th>
                      <th style="width: 90px">Ações</th>
                  </tr>
              </thead>
              <tbody>
                  <ng-template ngFor let-procedimento
                    [ngForOf]="listaProcedimentos | paginate: { currentPage: pageable.page, itemsPerPage: pageable.size, totalItems : pageable.totalElements }">
                      <tr>
                          <th scope="row">{{ procedimento.id }}</th>
                          <td>{{ procedimento.codigo }}</td>
                          <td>{{ procedimento.nome }}</td>
                          <td>R$ {{ procedimento.valorUnitario | number:'1.2-2' }}</td>
                          <td>
                            <div class="badge badge-status {{ procedimento.ativo ? 'badge-success-status' : 'badge-danger-status' }}">
                              {{ procedimento.ativo ? 'Ativo' : 'Inativo' }}
                            </div>
                          </td>
                          <td>
                              <a data-toggle="tooltip" title="Editar">
                                  <em class="fa fa-edit icon-table" (click)="alterarProcedimento(content, procedimento.id)"></em>
                              </a>&nbsp;
                              <a data-toggle="tooltip" title="Ativar Procedimento" *ngIf="!procedimento.ativo; else procInativo">
                                  <em class="fa fa-toggle-off icon-table" (click)="ativarProcedimento(procedimento.id)"></em>
                              </a>
                              <ng-template #procInativo>
                                <a data-toggle="tooltip" title="Inativar Procedimento">
                                  <em class="fa fa-toggle-on icon-table" (click)="inativarProcedimento(procedimento.id)"></em>
                                </a>
                              </ng-template>
                          </td>
                      </tr>
                  </ng-template>
              </tbody>
          </table>
      </div>

      <div class="d-flex justify-content-center">
        <pagination-controls [autoHide]="true" [responsive]="true" [previousLabel]="labels.previousLabel"
            [nextLabel]="labels.nextLabel" (pageChange)="pageChanged($event)"></pagination-controls>
      </div>
  </app-card>

  <!-- MODAL PARA CADASTRAR/ALTERAR OS PROCEDIMENTOS -->
  <ng-template #content let-closed="close" let-dismiss="dismiss">
      <form #frmProcedure="ngForm" autocomplete="off" (ngSubmit)="save(frmProcedure)">
          <div class="modal-header">
            <div class="container row me-0 pe-0">
              <div class="col">
                <h4 class="modal-title">Procedimento</h4>
              </div>
              <div class="col-auto">
                <div class="d-flex justify-content-end me-0 pe-0">
                  <button type="button" class="close" aria-label="Close" (click)="dismiss('click')">
                      <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body">
              <div class="row">
                  <div class="col-12">
                    <div class="mb-3">
                      <label class="required form-label" for="procedimento">Nome</label>
                      <input ngbAutofocus type="text" class="form-control" placeholder="Nome do procedimento" name="nome" required [(ngModel)]="procedimento.nome" #procedimentoNome="ngModel">
                      <app-message [control]="procedimentoNome" error="required" text="Campo obrigatório"></app-message>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="mb-3">
                      <label class="required form-label">Código</label>
                      <input class="form-control" type="text" placeholder="Código do procedimento" required name="codigo" [(ngModel)]="procedimento.codigo" #procedimentoCodigo="ngModel"/>
                      <app-message [control]="procedimentoCodigo" error="required" text="Campo obrigatório"></app-message>
                    </div>
                </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="mb-3">
                        <label class="required form-label">Valor Unitário</label>
                        <input class="form-control" placeholder="R$ 0,00" required currencyMask name="valorUnitario" [(ngModel)]="procedimento.valorUnitario" #procedimentoValor="ngModel" [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"/>
                        <app-message [control]="procedimentoValor" error="required" text="Campo obrigatório"></app-message>
                      </div>
                  </div>
              </div>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" (click)="dismiss('click')"> <i class="fa fa-times" aria-hidden="true"></i>&nbsp; Cancelar</button>
              <button type="submit" class="btn btn-primary" [disabled]="frmProcedure.invalid"> <i class="fa fa-check" aria-hidden="true"></i>&nbsp; Confirmar</button>
          </div>
      </form>
  </ng-template>
</div>
